import { CommonEnums } from 'src/app/shared/common.enums';

export class DxFlow {
    dxFlow_Id: number;
    layer_Id: number;
    nm: string;
    description: string;
    ver: string;
    paramFilePath: string;
    paramFileNm: string;
    valid_Cd: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    dxFlow_Type: string;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.layer_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.paramFilePath = CommonEnums.defaults.STRING_EMPTY;
        this.paramFileNm = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.dxFlow_Type = CommonEnums.defaults.OPS_FLOW_TYPE_REGULAR;
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
    }

    static parse(dxFlowTmp: any): DxFlow {
        let dxFlow: DxFlow = new DxFlow();
        dxFlow.copyFrom(dxFlowTmp as DxFlow);
        return dxFlow;
    }

    getPrimaryKey(): string {
        return this.dxFlow_Id.toString();
    }

    copy(): DxFlow {
        let dxFlowTmp: DxFlow = new DxFlow();

        dxFlowTmp.dxFlow_Id = this.dxFlow_Id;
        dxFlowTmp.layer_Id = this.layer_Id;
        dxFlowTmp.nm = this.nm;
        dxFlowTmp.description = this.description;
        dxFlowTmp.ver = this.ver;
        dxFlowTmp.paramFilePath = this.paramFilePath;
        dxFlowTmp.paramFileNm = this.paramFileNm;
        dxFlowTmp.valid_Cd = this.valid_Cd;
        dxFlowTmp.updateBy = this.updateBy;
        dxFlowTmp.lastUpdateBy = this.lastUpdateBy;
        dxFlowTmp.updateDt = this.updateDt;
        dxFlowTmp.dxFlow_Type = this.dxFlow_Type;
        dxFlowTmp.change_Ind = this.change_Ind;
        dxFlowTmp.error_Cd = this.error_Cd;
        dxFlowTmp.error_Msg = this.error_Msg;

        return dxFlowTmp;
    }

    copyFrom(dxFlowTmp: DxFlow): void {
        this.dxFlow_Id = dxFlowTmp.dxFlow_Id;
        this.layer_Id = dxFlowTmp.layer_Id;
        this.nm = dxFlowTmp.nm;
        this.description = dxFlowTmp.description;
        this.ver = dxFlowTmp.ver;
        this.paramFilePath = dxFlowTmp.paramFilePath;
        this.paramFileNm = dxFlowTmp.paramFileNm;
        this.valid_Cd = dxFlowTmp.valid_Cd;
        this.updateBy = dxFlowTmp.updateBy;
        this.lastUpdateBy = dxFlowTmp.lastUpdateBy;
        this.updateDt = dxFlowTmp.updateDt;
        this.dxFlow_Type = dxFlowTmp.dxFlow_Type;
        this.change_Ind = dxFlowTmp.change_Ind;
        this.error_Cd = dxFlowTmp.error_Cd;
        this.error_Msg = dxFlowTmp.error_Msg;
    }

    compare(dxFlowTmp: DxFlow): string {
        let dxFlowString: string = this.toString(false);
        let dxFlowTmpString: string = dxFlowTmp.toString(false);

        if (dxFlowString != dxFlowTmpString) {
            return dxFlowString + ', ' + dxFlowTmpString;
        }
        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DxFlow [dxFlow=" + this.dxFlow_Id + ", layer_Id=" + this.layer_Id + ", nm=" + this.nm +
            ", description=" + this.description + ", paramFilePath=" + this.paramFilePath +
            ", paramFileNm=" + this.paramFileNm + ", valid_Cd=" + this.valid_Cd + ", dxFlow_Type=" + this.dxFlow_Type;

        if (isNotCompare) {
            str += ", ver=" + this.ver + ", change_Ind=" + this.change_Ind + ", updateBy=" + this.updateBy +
                ", lastUpdateBy=" + this.lastUpdateBy + ", updateDt=" + this.updateDt +
                ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg;
        }

        str += ']';
        return str;
    }
}